// Fields, defaults, and library info for this section. The editor builds its form from `fields`.
const definition = {
  order: 120,
  type: "video",
  name: "Video",
  category: "Promotional",
  description: "A YouTube, Vimeo, or video file on the home page",
  defaultSettings: {
    heading: "See it in motion",
    caption: "",
    videoUrl: "",
    posterUrl: "",
    ratio: "16:9",
    autoplay: false,
  },
  fields: [
    { key: "heading", label: "Heading", type: "text" },
    { key: "caption", label: "Caption", type: "textarea" },
    { key: "videoUrl", label: "Video link", type: "text", placeholder: "YouTube, Vimeo, or an .mp4 link" },
    { key: "posterUrl", label: "Cover image", type: "image", hint: "Shown before the video plays. A file link can use this as its poster." },
    {
      key: "ratio",
      label: "Shape",
      type: "select",
      options: [
        { value: "16:9", label: "Wide 16:9" },
        { value: "4:3", label: "Standard 4:3" },
        { value: "1:1", label: "Square" },
        { value: "9:16", label: "Tall 9:16" },
      ],
    },
    { key: "autoplay", label: "Play automatically, muted", type: "toggle" },
  ],
};

export default definition;
